export default __webpack_public_path__ + "static/media/error_24px.77e8b852.svg";